import { render, staticRenderFns } from "./user-password-reset-request.vue?vue&type=template&id=4f55bd8a&scoped=true"
import script from "./user-password-reset-request.vue?vue&type=script&lang=js"
export * from "./user-password-reset-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55bd8a",
  null
  
)

export default component.exports